export default "/public/dist/img/hintLogo.png";